export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  }
};